import AnalyticsManagerBase from "./../../../src/common/analytics/analyticsmanagerbase";
import AnalyticsEngineER from "./../../../src/common/analytics/engines/analyticsEngineER";
import AnalyticsEngineGTM from "./engines/analyticsEngineGTM";
import AnalyticsEngineXiTi from "./engines/analyticsEngineXiTi";
import CmpManager from "./../../../src/common/cmp/cmpManager";
import { CmpType } from "./../../../src/common/utilities/enums";

export default class AnalyticsManager extends AnalyticsManagerBase {
  constructor(options) {
    super(options);
    this._initEngines();
    this.cmpManager = new CmpManager(CmpType.DIDOMI, options.cmp);
    //Try Initialize analytics engine only after the CMP script has loaded
    this.cmpManager.on("cmp:loaded", () => {
      this._initCMPRequiredEngines();
    });

    //When the user give consent we load the script if it has not been loaded yet
    this.cmpManager.on("userConsent:changed", () => {
      this._initCMPRequiredEngines();
      this.trigger("userConsent:changed");
    });
  }

  _initEngines() {
    new AnalyticsEngineGTM(this, this._options); // eslint-disable-line
    this.Xiti = new AnalyticsEngineXiTi(this, this._options); // eslint-disable-line
  }

  _initCMPRequiredEngines() {
    //The script cannot be loaded if the user has not given any consent
    if (!this.ER && this.cmpManager.isERTrackingEnabled() == true) {
      this.ER = new AnalyticsEngineER(this, this._options); // eslint-disable-line
    }
  }
}



// WEBPACK FOOTER //
// ./clients/tel-tel/js/analyticsManager.js